// extracted by mini-css-extract-plugin
export default {"modalContainer":"ValidateSessionNotification_modalContainer__SC0WZ","header":"ValidateSessionNotification_header__jmnVE"};